import { GatsbyImageProps } from 'gatsby-plugin-image';
import { CSSProperties } from 'react';
import { ContentfulAsset } from '../../../features/entities/general-entities';
import StandardImage from './StandardImage';
import { GatsbyImageStyled } from './styles';
import ImageSvg from './svg';
import useMediaAssetProps from './use-media-asset-props';

export interface GeneralMediaAssetProps
  extends Omit<GatsbyImageProps, 'image' | 'alt'> {
  asset: ContentfulAsset;
  className?: string;

  loading?: 'eager' | 'lazy' | undefined;
  onClick?: (...attr: any) => void;
  objectFit?: CSSProperties['objectFit'];
  alt?: string;
  fallback?: string;
}

export interface ViewMediaAssetProps {
  width?: number;
  height?: number;
  style?: CSSProperties;
}

export interface MediaAssetProps
  extends GeneralMediaAssetProps,
    ViewMediaAssetProps {
  tablet?: ViewMediaAssetProps;
  xl?: ViewMediaAssetProps;
  xxl?: ViewMediaAssetProps;
}

const MediaAsset = (props: MediaAssetProps) => {
  const { generalProps, assetProps } = useMediaAssetProps(props);

  return !!generalProps.image ? (
    <>
      <GatsbyImageStyled {...generalProps} {...assetProps} />
    </>
  ) : !!props.asset.svgContent ? (
    <ImageSvg {...props} />
  ) : !!generalProps.path ? (
    <StandardImage generalProps={generalProps} assetProps={assetProps} />
  ) : (
    <></>
  );
};

export default MediaAsset;
